import { call, put, takeLatest, all, select } from "redux-saga/effects";
import { fetchExpressData } from "../../services/expressDataService";
import { loadExpress } from "../../utils/expressIntegration";
import { LOAD_EXPRESS_DATA_REQUEST } from "./constants";
import { loadExpressDataSuccess, loadExpressDataFailure } from "./actions";

export function* loadExpressDataSaga(action) {
  try {
    const { purchaseLink, packageType } = action.payload;

    // Get canary version from Redux state
    const canaryVersion = yield select((state) => state.canaryVersion.version);

    // Fetch Express data with canary version
    const data = yield call(fetchExpressData, purchaseLink, canaryVersion);

    yield put(loadExpressDataSuccess(data));

    // Load Express with the fetched data
    loadExpress(data, packageType);
  } catch (error) {
    yield put(loadExpressDataFailure(error.message));
  }
}

export function* watchLoadExpressData() {
  yield takeLatest(LOAD_EXPRESS_DATA_REQUEST, loadExpressDataSaga);
}

export default function* expressSagas() {
  yield all([watchLoadExpressData()]);
}
